// TODO: mode等idの重複
// TODO: アクション毎の分岐

var EPK = EPK || {};
EPK.PharmacyList = EPK.PharmacyList || {};
EPK.PharmacyList.paramArray = EPK.PharmacyList.paramArray || [];
EPK.PharmacyList.arrayParamPrefix = ['service','business_day','recieve_day','business_time','equipment','barrierfree','consult'];

EPK.PharmacyList.params = EPK.common.params;
// EPK.PharmacyList.query = EPK.common.query;
EPK.PharmacyList.cond = jQuery.extend({}, EPK.common.params, EPK.common.query);

EPK.PharmacyList.detailInitialized = false;
EPK.PharmacyList.cityInitialized = false;
EPK.PharmacyList.stationlInitialized = false;
EPK.PharmacyList.lineInitialized = false;
EPK.PharmacyList.prefInitialized = false;

EPK.PharmacyList.suggestedParams = {};

// ブックマークライブラリを有効可
EPK.PharmacyBookmark = EPK.PharmacyBookmark || {};
EPK.PharmacyBookmark.enable = true;
EPK.PharmacyBookmark.prefCD = EPK.PharmacyList.prefCd;
EPK.PharmacyBookmark.onText = "★";
EPK.PharmacyBookmark.offText = "★";
if (EPK.common.isMobile) {
	EPK.PharmacyBookmark.onText = "★";
	EPK.PharmacyBookmark.offText = "★";
}
EPK.PharmacyList.selectedPopup = "city";
EPK.PharmacyList.openSuggest = false;
if(EPK.mapArgs && EPK.mapArgs.shopList && !EPK.PharmacyList.shopList){
	EPK.PharmacyList.shopList = EPK.mapArgs.shopList;
}
EPK.PharmacyList.shops = {};
$.each(EPK.PharmacyList.shopList,function(index,val){
	EPK.PharmacyList.shops[val.id] = val;
});

// ブランドチラシ用のデータ格納先確保
EPK.PharmacyList.selectBrandTirashiArea = EPK.PharmacyList.selectBrandTirashiArea || null;
EPK.Condition = EPK.Condition || {};


EPK.PharmacyList.pharmacyAlertCallback = function($elem, shop_id){
	var $tmp = $("#js-block-opentime-tmp_" + shop_id);
	var src = $("#js-block-opentime_src" + shop_id);
	src.id = "js-block-opentime_" + shop_id;
	$tmp.replaceWith(function() {
		return src;
	});
	setTimeout(function(){
		EPK.utils.initTab('alert-box-area-' + shop_id, true)
	}, 50);
};

EPK.PharmacyList.getShohoStatus = function(){
	EPK.common = EPK.common || {};
	EPK.common.ShohoData = null;
	var url = "/api/shoho/check.json";
	var d = $.Deferred();
	return $.ajax({
		type: 'get',
		url: url,
		data: {"shop_id": Object.keys(EPK.PharmacyList.shops)},
		cache: false,
		timeout: 60000
	}).done(function(data){
		EPK.common.ShohoData = data;
		$('.loading_reservation_status').each(function(index, elem){
			var $elem = $(elem);
			var $template = $($elem.attr('data-template'));
			var shop_id = $elem.attr('data-shop_id');
			var callbackName = $elem.attr('data-callback');
			var label = $elem.attr('data-label') || "";

			var shop = EPK.PharmacyList.shops[shop_id];
			var shoho = data[shop_id];
			var callback = callbackName? EPK.PharmacyList[callbackName] : function(){};
			shop['is_open'] = $elem.attr('data-is_open') || false;
			shop['is_express'] = $elem.attr('data-is_express') || false;
			shop['extra_opentimes'] = $elem.attr('data-extra_opentimes') || false;

			shop['dispWebToFax'] = false;
			shop['dispReadyEmail'] = false;
			shop['dispOutTime'] = false;

			if(shop['shohobin_flag']
				&& shoho["reserve_flag"]==0
				&& shoho["use_shoho_flag"]
			){
				if(shoho['today_receipt_flag']==1){
					shop['dispOutTime'] = true;
				}
				shop['dispWebToFax'] = shop['webtofax'];
				shop['dispReadyEmail'] = shop['ready_email_no_send_flag'];
			}

			shop['dispSubAlert'] = shop['dispWebToFax'] || shop['dispReadyEmail'] || shop['extra_opentimes'];

			var params = {
				shoho: data[shop_id],
				shop: shop,
				label: label
			};
			var html = $template.render(params);
			$elem.replaceWith(function() {
				return html;
			});
			callback($elem, shop_id);
		});
		d.resolve();
	}).fail(function(err){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
		d.reject(err);
	});
};

/*
EPK.PharmacyList.getAdShopIds = function(){
	var result = [];
	$('.ad-shop-container').each(function(index, elem){
		result.push($(elem).data("shop_id"));
	});
	return result;
};

EPK.PharmacyList.getShohoStatusAdShop = function(){
	EPK.common = EPK.common || {};
	EPK.common.ShohoData = null;
	var url = "/api/shoho/check.json";
	$.ajax({
		type: 'get',
		url: url,
		data: {"shop_id": EPK.PharmacyList.getAdShopIds()},
		cache: false,
		timeout: 60000
	}).done(function(data){
		EPK.common.ShohoData = data;
		$('.ad-shop-container').each(function(index, elem){
			var shop_id = $(elem).data("shop_id");
			var shoho = data[shop_id];
			if(shoho && shoho["use_shoho_flag"]){
				$("#advertising_box .loading_image").hide();
				$('#advertising_box_inner').show();
				$('#advertising_box_inner').show();
				$(elem).show();
			} else {
				$(elem).remove();
			}
		});
		if($('.ad-shop-container').length <= 0){
			$("#advertising_box").remove();
		}
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};
*/

/**
 * #20377 広告枠基盤参照
 * 広告枠店舗の非同期取得
 * @method getShohoStatusAdShop
 */
EPK.PharmacyList.getShohoStatusAdShop = function(){

	var addContainer = document.querySelector('.list-ad');

	//EPK.PharmacyList.searchAdQueryがfalseの場合は削除
	if (!EPK.PharmacyList.searchAdQuery && addContainer){
		addContainer.parentNode.removeChild(addContainer);
	} else if(EPK.PharmacyList.searchAdQuery && addContainer) {
		$.ajax({
			type: 'get',
			url: '/api/list/ad_shop' + EPK.PharmacyList.searchAdQuery,
			cache: false,
			timeout: 60000
		}).done(function(data){
			if (addContainer && data) {
				addContainer.innerHTML = data;
			}
			if($('.ad-shop-container').length <= 0){
				$(".list-ad").remove();
			} else {
				// 調剤ミス防止システム導入店のホップアップ再登録
				EPK.utils.openPopup('.modal-mispreve-label-btn');
			}
		}).fail(function(){
			// アクション側でExceptionが投げられた場合はここに来る。
			// エラーをここで処理したい場合はExceptionを投げても良い

			//ローディング画像がのこるので削除する
			addContainer.parentNode.removeChild(addContainer);
		});
	}
};

/**
 * #
 * @method getBnEPrescriptionImageFile
 */
EPK.PharmacyList.getBnEPrescriptionImageFile = function(){

	if (typeof EPK.PharmacyList.shopList === 'undefined') {
		return;
	}

	var url = location.href;
	var query = "";

	// #22422 リスト_分包紙対応店舗導線追加 電子処方箋バナーも修正
	if (url.indexOf('is_erx=1') >= 0) {
		//is_erx=1が入っている時は、「電子処方箋の予約もカンタン」バナー
		$('#bn_erx_read').show();
		$('#loading_erx').hide();
	} else {
		// 電子処方箋予約できる店舗が1件でもあるかチェック
		query = EPK.PharmacyList.getQuery({'is_erx': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data > 0){
				// 「電子処方箋の予約も対応しています」バナー
				$('#bn_erx').show();
			}
			$('#loading_erx').hide();
		});
	}

	// #22422 リスト_分包紙対応店舗導線追加
	if (url.indexOf('is_packagingpaper=1') >= 0) {
		$('#loading_packagingpaper').hide();
	} else {
		query = EPK.PharmacyList.getQuery({'is_packagingpaper': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data > 0){
				$('#bn_packagingpaper').show();
			}
			$('#loading_packagingpaper').hide();
		});
	}
};

/**
 * スライダー初期化
 */
EPK.PharmacyList.initSwiper = function(){
	var id = "#map-shoplist-panels";
	$(id).swiper({
		slidesPerView: 4,
		spaceBetween: 10,
		centeredSlides: true,
		grabCursor: true,
		loop: true,
		preloadImages: true,
		paginationClickable: true,
		nextButton: id + ' .swiper-button-next',
		prevButton: id + ' .swiper-button-prev'
	});
};

EPK.PharmacyList.init = function(){
	EPK.PharmacyList.$popupBtns = {
		"pref": $('#modal-select-pref-btn'),
		"city": $('#modal-select-city-btn'),
		"detail": $('#modal-select-detail-btn'),
		"line": $('#modal-select-line-btn'),
		"station": $('#modal-select-station-btn'),
	};

	EPK.PharmacyList.$popups = {
		"pref": $('#modal-select-pref'),
		"city": $('#modal-select-city'),
		"detail": $('#modal-select-detail'),
		"line": $('#modal-select-line'),
		"station": $('#modal-select-station'),
	};

	EPK.PharmacyList.$popupForms = {
		"city": $('#form-modal-select-city'),
		"detail": $('#form-modal-select-detail'),
		"line": $('#form-modal-select-line'),
		"station": $('#form-modal-select-station'),
	};
	EPK.PharmacyList.$submitBtns = {
		"city":  $("#modal-city-submit-button"),
		"detail":  $("#modal-detail-submit-button"),
		"line":  $("#modal-line-submit-button"),
		"station":  $("#modal-station-submit-button"),
	};
	EPK.PharmacyList.$reselectBtns = {
		"city":  $("#modal-city-reselect-button"),
		"station":  $("#modal-station-reselect-button"),
		"detail":  $("#modal-detail-reselect-button")
	};

	return false;
};

/**
 * #9440 店舗情報のアイコン呼び出し処理変更
 */

// 混雑状況（リスト）の非同期取得
EPK.PharmacyList.getDispensingQueue = function(){
	var url = "/api/list/dispensing_queue";
	var shopIds = Object.keys(EPK.PharmacyList.shops);
	var eparkReservePriorFlags = shopIds.map(function(id) {
		return EPK.PharmacyList.shops[id].epark_reserve_prior_flag;
	});
	var d = $.Deferred();

	return $.ajax({
		type: 'get',
		url: url,
		data: {
			"shop_id": shopIds,
			"epark_reserve_prior_flag": eparkReservePriorFlags
		},
		cache: false,
		dataType : 'json',
		timeout: 60000
	}).done(function(data){
		for (var key in data) {
			if (!data.hasOwnProperty(key)) {
				continue;
			}
			var targetShopEl = document.getElementById('shop_id_' + key);
			if (!targetShopEl) {
				continue;
			}
			var appealEl = targetShopEl.querySelector('.appeal');
			if (!appealEl) {
				continue;
			}
			appealEl.outerHTML = data[key];

			/*
			var reserveSubEl = targetShopEl.querySelector('.st-reserve-sub-area');
			if (!reserveSubEl) {
				continue;
			}
			reserveSubEl.insertAdjacentHTML('beforebegin', data[key]);

			// 右側のリスト
			// 混雑状況エリア
			var congestionAreaEl = targetShopEl.querySelector('.congestion-area');

			// クーポン
			var couponEl = targetShopEl.querySelector('.list-coupon');

			// ボタンバルーン
			var buttonBaloonEl = targetShopEl.querySelector('.button-baloon');

			// ボタン
			var reserveButtonEl = targetShopEl.querySelector('.st-button-block .loading_reservation_status.loading_reservation_status-main');

			// 混雑ボタン
			var congestionButtonAreaEl = targetShopEl.querySelector('.congestion-btn');

			// 混雑 調剤開局時間の注意事項
			var congestionBtnSubtextEl = targetShopEl.querySelector('.congestion-btn-subtext');

			// 調剤開局時間の注意事項
			var reserveSubtextEl = targetShopEl.querySelector('.st-reserve-subtext');

			if (couponEl) {
				congestionAreaEl.insertAdjacentElement('beforebegin', couponEl);
			}

			if (buttonBaloonEl) {
				congestionAreaEl.insertAdjacentElement('beforebegin', buttonBaloonEl);
			}

			congestionButtonAreaEl.insertAdjacentElement('afterbegin', reserveButtonEl);

			congestionBtnSubtextEl.innerHTML = '';
			for (var i = 0, count = reserveSubtextEl.childElementCount; i < count; i++) {
				congestionBtnSubtextEl.insertAdjacentElement('beforeend', reserveSubtextEl.children[0]);
			}

			// 左側のリスト
			// ゲタ
			var getaEl = targetShopEl.querySelector('.baloon-box.static');

			// 営業時間
			var salesTimeEl = targetShopEl.querySelector('.st-sales-time');

			// ネット受付なら
			var baloonEl = targetShopEl.querySelector('.reserve-btn-baloon');

			// メリット文言
			var pharmacyAlertEl = targetShopEl.querySelector('.st-list-detail-body>.loading_reservation_status.loading_reservation_status-main');

			getaEl.insertAdjacentElement('beforebegin', salesTimeEl);

			if (pharmacyAlertEl) {
				getaEl.insertAdjacentElement('afterend', pharmacyAlertEl);
			}

			getaEl.insertAdjacentElement('afterend', baloonEl);

			// 削除
			// クーポンがない場合はゲタを消す
			if (!couponEl) {
				getaEl.parentNode.removeChild(getaEl);
			}
			reserveSubEl.parentNode.removeChild(reserveSubEl);
			var reserveButtonAreaEl = targetShopEl.querySelector('.st-reserve-button-area');
			reserveButtonAreaEl.parentNode.removeChild(reserveButtonAreaEl);
			*/
		}

		// 店舗詳細のホップアップ再登録
		[
		 '.modal-alert-btn',
		 '.modal-dispensing-queue-btn'
		].forEach(function(btnId){
			EPK.utils.openPopup(btnId);
		});

		d.resolve();
	}).fail(function(err){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
		// console.log(err);
		d.reject(err);
	});
};

// 本日の営業時間（リスト）の非同期取得
EPK.PharmacyList.getTodayOpenTime = function(){
	var url = "/api/list/today_open_time";
	var d = $.Deferred();
	var shopIds = Object.keys(EPK.PharmacyList.shops);
	var pharmacyType = shopIds.map(function(id) {
		return EPK.PharmacyList.shops[id].pharmacy_type;
	});
	// #19559 処方箋受付機(回収機)訴求
	var prescriptionCollectionMachineFlags = shopIds.map(function(id) {
		return EPK.PharmacyList.shops[id].prescription_collection_machine_flag;
	});

	return $.ajax({
		type: 'get',
		url: url,
		data: {
			"shop_id": shopIds,
			"pharmacy_type": pharmacyType,
			"pcm_flag": prescriptionCollectionMachineFlags
		},
		cache: false,
		dataType : 'html',
		timeout: 60000
	}).done(function(data){
		data = '<div id="wrap_opentime">' + data + '</div>';
		document.querySelector('body').insertAdjacentHTML('beforeend', data);
		var openTimes = document.querySelectorAll('[id^=opentime_]');

		for (var i = 0; i < openTimes.length; i++) {
			var openTimeEl = openTimes[i];
			var targetShopEl = document.getElementById('shop_id_' + openTimeEl.id.replace('opentime_', ''));
			if (!targetShopEl) {
				continue;
			}
			var salesTimeEl = targetShopEl.querySelector('.sales');
			salesTimeEl.outerHTML = openTimeEl.outerHTML;
		}
		document.getElementById('wrap_opentime').parentNode.removeChild(document.getElementById('wrap_opentime'));

		d.resolve();
	}).fail(function(err){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
		// console.log(err);
		d.reject(err);
	});
};

// お気に入り（リスト）の非同期取得
EPK.PharmacyList.getBookmark = function(){
	var url = "/api/list/bookmark";
	$.ajax({
		type: 'get',
		url: url,
		data: {"shop_id": Object.keys(EPK.PharmacyList.shops)},
		cache: false,
		dataType : 'json',
		timeout: 60000
	}).done(function(idList){
		// お気に入り済み処理
		for (var i = 0; i < idList.length; i++) {
			var targetShopEl = document.getElementById('shop_id_' + idList[i]);
			if (!targetShopEl) {
				continue;
			}
			var favoriteButtonEl = targetShopEl.querySelector('.list-favorite a');
			favoriteButtonEl.innerText = EPK.PharmacyBookmark.onText;
			favoriteButtonEl.classList.toggle('off');
			favoriteButtonEl.classList.toggle('on');
		}

		// 再登録
		EPK.PharmacyBookmark.resettingBookmarkBtn();
		// 活性化
		var favoriteList = document.querySelectorAll('.list-favorite');
		Array.prototype.forEach.call(favoriteList, function(favoriteEl) {
			favoriteEl.querySelector('img').parentNode.removeChild(favoriteEl.querySelector('img'));
			favoriteEl.querySelector('a').style.display = 'block';
		});
	}).fail(function(err){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
		// console.log(err);
	});
};

// チラシの非同期取得
EPK.PharmacyList.getShopChirashiView = function(){
	var url = "/api/list/shop_chirashi_view";
	$.ajax({
		type: 'get',
		url: url,
		data: {"shop_id": Object.keys(EPK.PharmacyList.shops)},
		cache: false,
		dataType : 'html',
		timeout: 60000
	}).done(function(data) {
		data = '<div id="wrap_chirashi">' + data + '</div>';
		document.querySelector('body').insertAdjacentHTML('beforeend', data);
		var chirashis = document.querySelectorAll('[id^=chirashi_]');
		for (var i = 0; i < chirashis.length; i++) {
			var chirashiEl = chirashis[i];
			var shop_id = chirashiEl.id.replace('chirashi_', '');
			var url = EPK.PharmacyList.shops[shop_id].url + '/coupon';
			var urlEl = chirashiEl.querySelector('.chirashi_url');
			urlEl.outerHTML = '<a href="' + url + '">この店舗のチラシをもっと見る</a>';
			var targetShopEl = document.getElementById('shop_id_' + chirashiEl.id.replace('chirashi_', ''));
			if (!targetShopEl) {
				continue;
			}
			var targetChirashiEl = targetShopEl.querySelector('.flyer');
			if (!targetChirashiEl) {
				continue;
			}
			targetChirashiEl.outerHTML = chirashiEl.outerHTML;
		}
		document.getElementById('wrap_chirashi').parentNode.removeChild(document.getElementById('wrap_chirashi'));

		var shops = document.querySelectorAll('[id^=shop_id_]');
		for (var i = 0; i < shops.length; i++) {
			var elFlyer = shops[i].querySelector('.flyer-box');
			var elCoupon = shops[i].querySelector('.coupon');
			if (!elFlyer && !elCoupon) {
				// チラシもクーポンも無ければ領域を削除
				var elFlyerCoupon = shops[i].querySelector('.flyer-coupon');
				elFlyerCoupon.parentNode.removeChild(elFlyerCoupon);
			} else if (!elFlyer) {
				// ローディング画像を削除
				var img = shops[i].querySelector('.flyer');
				if (!img) {
					continue;
				}
				img.parentNode.removeChild(img);
			}
		}
	}).fail(function(err) {
	});
};

// 商品の非同期取得
EPK.PharmacyList.getToriokiShopItem = function(){
	var url = "/api/list/torioki_shop_item";
	$.ajax({
		type: 'get',
		url: url,
		data: {"shop_id": Object.keys(EPK.PharmacyList.shops)},
		cache: false,
		dataType : 'html',
		timeout: 60000
	}).done(function(data) {
		data = '<div id="wrap_torioki">' + data + '</div>';
		document.querySelector('body').insertAdjacentHTML('beforeend', data);
		var toriokis = document.querySelectorAll('[id^=torioki_]');
		for (var i = 0; i < toriokis.length; i++) {
			var toriokiEl = toriokis[i];
			var shop_id = toriokiEl.id.replace('torioki_', '');
			var url = EPK.PharmacyList.shops[shop_id].url + '/shop_torioki_item';
			var urlEl = toriokiEl.querySelector('.torioki_url');
			urlEl.outerHTML = '<a href="' + url + '">もっと見る</a>';
			var targetShopEl = document.getElementById('shop_id_' + shop_id);
			if (!targetShopEl) {
				continue;
			}
			var targetToriokiEl = targetShopEl.querySelector('.list-torioki-img');
			if (!targetToriokiEl) {
				continue;
			}
			targetToriokiEl.outerHTML = toriokiEl.outerHTML;
		}
		document.getElementById('wrap_torioki').parentNode.removeChild(document.getElementById('wrap_torioki'));

		var shops = document.querySelectorAll('[id^=shop_id_]');
		for (var i = 0; i < shops.length; i++) {
			var torioki = shops[i].querySelector('.list-torioki-box');
			if (!torioki) {
				// ローディング画像を削除
				var img = shops[i].querySelector('.list-torioki-img');
				if (!img) {
					continue;
				}
				img.parentNode.removeChild(img);
			}
		}
	}).fail(function(err) {
	});
};

// ポイントデーの非同期取得
EPK.PharmacyList.displayShopsPointDate = function(){
	var shopPointDateEls = document.querySelectorAll('.point-label');
	if(!shopPointDateEls.length) {
		return;
	}
	var shopIds = [];
	var prefs = [];
	Array.prototype.map.call(shopPointDateEls, function(el) {
		shopIds.push(el.getAttribute('data-shopid') || 0);
		prefs.push(el.getAttribute('data-pref') || 0);
	});

	// 描画処理
	if(!shopIds.length || !prefs.length) {
		return;
	}

	// データの取得
	$.ajax({
		type: 'get',
		url: '/api/coupons/get_point_date',
		data: {
			'shop_id': shopIds,
			'pref': prefs
		},
		cache: false,
		timeout: 60000
	}).done(function(data){
		Array.prototype.forEach.call(shopIds, function(id, index) {
			var targetEl = shopPointDateEls[index];
			var childrenStrEl = (data[id] !== undefined) ? data[id] : null;

			// 描画
			if (childrenStrEl == "undefined" || childrenStrEl == null || childrenStrEl == '') {
				if (targetEl.children.length == 0) {
					targetEl.style.display = 'none';
				}
			}else if (targetEl) {
				targetEl.insertAdjacentHTML('afterbegin', childrenStrEl);
			}
		});
	}).fail(function(){
	});
};

// 店舗詳細の組み立て
EPK.PharmacyList.buildShopDetail = function() {
	$.when(
		EPK.PharmacyList.getDispensingQueue(),
		EPK.PharmacyList.getTodayOpenTime(),
		EPK.PharmacyList.getShopChirashiView(),
		// #14201 PCリスト　取り置き枠の削除
		// EPK.PharmacyList.getToriokiShopItem(),
		EPK.PharmacyList.displayShopsPointDate()
	)
	.then(EPK.PharmacyList.getShohoStatus)
	.fail(function(err) {
		console.log(err);
	});
}

/**
 *
 */
$(function(){

	//初期読み込み
	EPK.PharmacyList.init();
	//EPK.PharmacyList.calcShopCount($('.research_check'), $('#btnReSearch'));

	if (Object.keys(EPK.PharmacyList.shops).length) {
		EPK.PharmacyList.buildShopDetail();
		if(EPK.common.isLogin){
			EPK.PharmacyList.getBookmark();
		}
	}
	EPK.PharmacyList.getShohoStatusAdShop();
	EPK.PharmacyList.getBnEPrescriptionImageFile();

	/**
	 * TODO: 高速化 EPK.PharmacyList以下に変数に渡す
	 * @type {*}
	 */
	var $select_days_no_day = $('#no_day');
	var $select_days_today = $('#today');
	var $select_days_tomorrow = $('#tomorrow');
	var $select_days_sunday = $('#sunday');
	var $select_days_opendates = [$select_days_today, $select_days_tomorrow];

	var $is_net = $('#is_net');
	var $is_open = $('#is_open');
	var $is_coupon = $('#is_coupon');
	var $link_to_map = $('#link_to_map');
	var $is_pc = $('#is_pc');
	var $area_key = $('#area_key');
	var $line_key = $('#line_key');
	var $pref_key = $('#pref_key');
	var $mode = $('#mode');
	var $km_brand_page_id = $('#km_brand_page_id');
	var modeStr = $mode.attr('value');

	// 上部検索項目
	var $narrow_selected = $('.narrow-selected a');
	var $narrow_fun = $('.narrow-fun a');
	var $narrow_fun_is_net = $('#narrow_fun_is_net');
	var $narrow_fun_is_open = $('#narrow_fun_is_open');
	var $narrow_fun_is_receive_open = $('#narrow_fun_is_receive_open');
	var $narrow_fun_is_coupon = $('#narrow_fun_is_coupon');
	var $narrow_fun_is_chirashi = $('#narrow_fun_is_chirashi');
	var $narrow_fun_is_card = $('#narrow_fun_is_card');

	//PC初期処理
	if(($is_pc.length>0)&&($is_pc.val()==1)){
		var area_query = "";
		var station_query = "";
		var tmp = [];

		/**
		 * ポップアップの初期化
		 */
		EPK.PharmacyList.initPrefPopup();
		EPK.PharmacyList.initLinePopup(EPK.PharmacyList.prefCd);
		EPK.PharmacyList.initStationPopup(EPK.PharmacyList.prefCd);
		EPK.PharmacyList.initCityPopup(EPK.PharmacyList.prefCd);
		EPK.PharmacyList.initDetailPopup(EPK.PharmacyList.prefCd);
		//EPK.PharmacyList.initAreaStationPopup(EPK.PharmacyList.prefCd);
	}
	// SP初期処理
	else {
		EPK.PharmacyList.initCriteriasSwiper();
	}

	//災害安心サポートLPからの遷移かつ、tab=distanceがセットされているが緯度経度がセットされていない場合、近い順で表示のイベントを発火
	$(function(){
		if(document.referrer.indexOf('lp/disaster_support') != -1 && location.search.match('tab=distance') && (!location.search.match('current_lat') && !location.search.match('current_lon'))){
		$('#search-sort-close').trigger("click");
		}
	});

	/* 「近い順」「標準」切り替え
	 * (#7377対応)
	 */
	$('#sort_tab_button').on('click', function(e) {
		// 現在「近い順」で表示している場合は「標準」表示へ切り替え
		if($(this).hasClass('close')) {
			EPK.PharmacyList.redirect2({
				'tab':'',
				'current_lat':'',
				'current_lon':''
			}, location.pathname);

		// 現在「標準」で表示している場合は「近い順」表示へ切り替え
		}else if($(this).hasClass('standard')) {
			var option = {
					'tab':'distance',
					'is_net': 1
			};
			if(EPK.common.latlng.lat && EPK.common.latlng.lng) {
				option["current_lat"] = EPK.common.latlng.lat;
				option["current_lon"] = EPK.common.latlng.lng;
			}
			EPK.PharmacyList.redirect2(option, location.pathname);
		}
	});


	//駅を検索
	EPK.PharmacyList.$submitBtns["line"].on('click', function(e){
		e.preventDefault();
		// console.log("line submitted");
		// ここでポップアップを開くと
		// このあとの処理で閉じちゃうので
		// setTimeOutで非同期化
		setTimeout(function(){
			$.magnificPopup.open({
				items: {src: '#modal-select-station'},
				type: 'inline',
			}, 0);
		}, 0);
	});

	// staion ポップアップ
	// line 再選択ボタン
	EPK.PharmacyList.$reselectBtns["station"].on('click', function(e){
		e.preventDefault();
		$('.line_check').prop("checked", false);
		setTimeout(function(){
			$.magnificPopup.open({
				items: {src: '#modal-select-line'},
				type: 'inline',
			}, 0);
		}, 0);
	});

	// city ポップアップ
	// detail 再選択ボタン
	EPK.PharmacyList.$reselectBtns["city"].on('click', function(e){
		e.preventDefault();
		// console.log("city submitted");
		setTimeout(function(){
			$.magnificPopup.open({
				items: {src: '#modal-select-detail'},
				type: 'inline',
			}, 0);
		}, 0);
	});

	// detail ポップアップ
	// city 再選択ボタン
	EPK.PharmacyList.$reselectBtns["detail"].on('click', function(e){
		e.preventDefault();
		// console.log("city submitted");
		setTimeout(function(){
			$.magnificPopup.open({
				items: {src: '#modal-select-city'},
				type: 'inline',
			}, 0);
		}, 0);
	});

	/**
	 * 絞込再検索は同じurlで実施
 	 */
	if(location.pathname !== "/condition"){
		$("form.form-research").attr("action", location.pathname);
	}

	/**
	 * フォームの送信先url決定
	 */
	["detail", "city"].forEach(function logArrayElements(name, index, array) {
		// TODO: PharmacySearch.redirectに寄せたほうが良さそう
			EPK.PharmacyList.$popupForms[name].submit(function () {
				var param = $(this).serializeArray();
				var area_ids = [];
				var form_action = '';
				param.forEach(function logArrayElements(element, index, array) {
					if (element["name"] == "area_id[]") {
						area_ids.push(element);
					}
				});
				if (area_ids.length > 1) {
					form_action = "/" + EPK.PharmacyList.prefCd + "/list";
				} else {
					form_action = "/" + EPK.PharmacyList.prefCd + "/list/" + area_ids[0]["value"];
				}
				if(EPK.PharmacyList.cond.km_brand_page_id) {
					form_action = '/brand/' + EPK.PharmacyList.cond.km_brand_page_id + form_action;
				}
				$(this).attr("action", form_action);
			});
		}
	);
	["line", "station"].forEach(function logArrayElements(name, index, array) {
		// TODO: PharmacySearch.redirectに寄せたほうが良さそう
			EPK.PharmacyList.$popupForms[name].submit(function (e) {
				var param = $(this).serializeArray();
				var station_ids = [];
				var form_action = '';
				param.forEach(function logArrayElements(element, index, array) {
					if (element["name"] == "station_cd[]") {
						station_ids.push(element);
					}
				});
				if (station_ids.length > 1) {
					form_action = "/" + EPK.PharmacyList.prefCd + "/line/station/shop";
				} else {
					form_action = "/" + EPK.PharmacyList.prefCd + "/line/station/" + station_ids[0]["value"];
				}
				if(EPK.PharmacyList.cond.km_brand_page_id) {
					form_action = '/brand/' + EPK.PharmacyList.cond.km_brand_page_id + form_action;
				}
				$(this).attr("action", form_action);
			});
		}
	);
	//タブ切り替え
	$('#search-sort-standard').on('click', function() {
		EPK.PharmacyList.redirect2({
			'tab':'',
			'current_lat':'',
			'current_lon':'',
		}, location.pathname);
	});

	//タブ切り替え
	$('#search-sort-close').on('click', function() {
		// EPK.PharmacyList.redirect('tab','distance','');
		var option = {
			'tab':'distance',
			'is_net': 1
		};
		//#20143
		if (navigator.geolocation) {
			// 現在地を取得
			navigator.geolocation.getCurrentPosition(
				// [第1引数] 取得に成功した場合の関数
				function(position){
					var data = position.coords ;
					var lat = data.latitude;
					var lng = data.longitude;
					var inOneHour = new Date(new Date().getTime() + 60 * 60 * 1000);
					EPK.common.latlng.lat = lat;
					EPK.common.latlng.lng = lng;
					Cookies.set('lat', lat, { expires: inOneHour });
					Cookies.set('lng', lng, { expires: inOneHour });
					option["current_lat"] = lat;
					option["current_lon"] = lng
					EPK.PharmacyList.redirect2(option, location.pathname);
				},
				function () {
					//位置情報取得できない場合はtab=distance,is_net=1でリダイレクト
					EPK.PharmacyList.redirect2(option, location.pathname);
				},
				{
					"enableHighAccuracy": false,
					"timeout": 8000,
					"maximumAge": 2000,
				}
			);
		} // 未対応
		else if(showError) {
			var errorMessage = "現在地情報を取得できませんでした。<br>端末の設定より現在地情報サービスをオンにして下さい。";
			alert(errorMessage);
		}
	});

	$select_days_no_day.on('change', function(e) {
		if(this.checked){
			if(EPK.common.query['open_date']) {
				delete EPK.common.query['open_date'];
			}
			// 残す：is_net
			EPK.PharmacyList.redirect2({'is_net': "1"}, location.pathname, true);
		}
	});

	$.each($select_days_opendates, function(key, checkbox) {
		checkbox.on('change', function() {
			if(this.checked){
				if(EPK.common.query['open_date']){
					EPK.common.query['open_date'].push(this.value);
				}else {
					EPK.common.query['open_date'] = [this.value];
				}
				EPK.PharmacyList.redirect2({}, location.pathname, true);
			} else {
				if(EPK.common.query['open_date']) {
					EPK.common.query['open_date'] = EPK.common.query['open_date'].filter(function(date) {
						return date != this;
					}, this.value);
				}
				// 残す：is_net
				EPK.PharmacyList.redirect2({'is_net': "1"}, location.pathname, true);
			}
		});
	});

	$select_days_sunday.on('change', function() {
		if(this.checked){
			EPK.PharmacyList.redirect2({'business_day[]': 'sun'}, location.pathname, true);
		} else {
			if(EPK.common.query['service']) {
				EPK.common.query['service'] = EPK.common.query['service'].filter(function(day) {
					return day != 'sunday';
				});
			}
			if(EPK.common.query['business_day']) {
				EPK.common.query['business_day'] = EPK.common.query['business_day'].filter(function(day) {
					return day != 'sun';
				});
			}
			EPK.PharmacyList.redirect2({}, location.pathname, true);
		}
	});

	$is_net.on('change', function() {
		if(this.checked){
			// EPK.PharmacyList.redirect('is_net','1','');
			EPK.PharmacyList.redirect2({'is_net': "1"}, location.pathname, true);
		} else {
			// EPK.PharmacyList.redirect('is_net','','');
			EPK.PharmacyList.redirect2({'is_net': "0"}, location.pathname, true);
		}
	});

	$is_open.on('change', function() {
		if(this.checked){
			// EPK.PharmacyList.redirect('is_open','1','');
			EPK.PharmacyList.redirect2({'is_open': "1"}, location.pathname, true);
		} else {
			// EPK.PharmacyList.redirect('is_open','','');
			EPK.PharmacyList.redirect2({'is_open': "0"}, location.pathname, true);
		}
	});

	$is_coupon.on('change', function() {
		if(this.checked){
			EPK.PharmacyList.redirect2({'is_coupon': "1"}, location.pathname, true);
		} else {
			// EPK.PharmacyList.redirect('is_open','','');
			EPK.PharmacyList.redirect2({'is_coupon': "0"}, location.pathname, true);
		}
	});
	if(EPK.common.action !== "condition") {
		/**
		 * チェックボックス０件ならグレーアウト
		 */
		var query="";
		if(EPK.common.isMobile) {
			query = EPK.PharmacyList.getQuery({'open_date[]': $select_days_today[0].value}, true);
			EPK.PharmacySearch.getCountByQuery(query, function(data){
				if(data <= 0){
					$select_days_today.attr('disabled', 'disabled');
				}
			});
			query = EPK.PharmacyList.getQuery({'open_date[]': $select_days_tomorrow[0].value}, true);
			EPK.PharmacySearch.getCountByQuery(query, function(data){
				if(data <= 0){
					$select_days_tomorrow.attr('disabled', 'disabled');
				}
			});
			query = EPK.PharmacyList.getQuery({'service[]': 'sunday'}, true);
			EPK.PharmacySearch.getCountByQuery(query, function(data){
				if(data <= 0){
					$select_days_sunday.attr('disabled', 'disabled');
				}
			});
		}
		/*
		query = EPK.PharmacyList.getQuery({'is_coupon': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data <= 0){
				$is_coupon.attr('disabled', 'disabled');
				$narrow_fun_is_coupon.off();
			} else {
				$narrow_fun_is_coupon.addClass('is-active');
			}
		});
		*/
		query = EPK.PharmacyList.getQuery({'is_net': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data <= 0){
				$is_net.attr('disabled', 'disabled');
				$narrow_fun_is_net.off();
			} else {
				$narrow_fun_is_net.addClass('is-active');
			}
		});
		query = EPK.PharmacyList.getQuery({'is_open': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data <= 0){
				$is_open.attr('disabled', 'disabled');
				$narrow_fun_is_open.off();
			} else {
				$narrow_fun_is_open.addClass('is-active');
			}
		});
		query = EPK.PharmacyList.getQuery({'is_receive_open': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data <= 0){
				$narrow_fun_is_receive_open.off();
			} else {
				$narrow_fun_is_receive_open.addClass('is-active');
			}
		});
		query = EPK.PharmacyList.getQuery({'is_card': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data <= 0){
				$narrow_fun_is_card.off();
			} else {
				$narrow_fun_is_card.addClass('is-active');
			}
		});
		query = EPK.PharmacyList.getQuery({'is_chirashi': "1"}, true);
		EPK.PharmacySearch.getCountByQuery(query, function(data){
			if(data <= 0){
				$narrow_fun_is_chirashi.off();
			} else {
				$narrow_fun_is_chirashi.addClass('is-active');
			}
		});
	}

	$link_to_map.on('click', function(e){
		e.preventDefault();
		var href = $(this).attr('href');
		if($is_net[0].checked && !EPK.common.query['is_net']){
			href = href + "&is_net=1";
		}
		location.href = href;
	});

	//ページャ(前へ)
	$('.pager-prev').on('click', function(e) {
		e.preventDefault();
		EPK.PharmacyList.redirect2(
			{'p': $(this).attr('data-page')},
			location.pathname
		);
	});
	//ページャ(次へ)
	$('.pager-next').on('click', function(e) {
		e.preventDefault();
		EPK.PharmacyList.redirect2(
			{'p': $(this).attr('data-page')},
			location.pathname
		);
	});

	//ページャ(次へ)
	$('.pages').on('click', function(e) {
		e.preventDefault();
		EPK.PharmacyList.redirect2(
			{'p': $(this).attr('data-page')},
			location.pathname
		);
	});

	EPK.PharmacyList.bindResearchCheck();

	EPK.PharmacyList.$popupBtns['city'].on('click', function(e) {
		$(".city_check").prop("checked", false);
		if(EPK.PharmacyList.prefCd==""){
			// 全国が選択されていた時の市区ボタン処理
			EPK.PharmacyList.selectedPopup = "city";
			EPK.PharmacyList.$popupBtns['pref'].click();
			e.preventDefault();
		}
	});

	EPK.PharmacyList.$popupBtns['detail'].on('click', function(e) {
		if(EPK.PharmacyList.prefCd==""){
			// 全国が選択されていない時の詳細ボタン処理
			EPK.PharmacyList.selectedPopup = "city";
			EPK.PharmacyList.$popupBtns['pref'].click();
			e.preventDefault();
		}else if(EPK.PharmacyList.getCityCheckNum() <= 0){
			// 市区が選択されていない時の詳細エリアボタン処理
			EPK.PharmacyList.$popupBtns['city'].click();
			e.preventDefault();
		}
	});

	EPK.PharmacyList.$popupBtns['line'].on('click', function(e) {
		$(".line_check").prop("checked", false);
		if(EPK.PharmacyList.prefCd==""){
			// 全国が選択されていた時の路線ボタン処理
			EPK.PharmacyList.selectedPopup = "line";
			EPK.PharmacyList.$popupBtns['pref'].click();
			e.preventDefault();
		}
	});

	EPK.PharmacyList.$popupBtns['station'].on('click', function(e) {
		console.log("station clicked");
		if(EPK.PharmacyList.prefCd==""){
			console.log("station clicked3a");
			// 全国が選択されていない時の詳細ボタン処理
			EPK.PharmacyList.selectedPopup = "line";
			EPK.PharmacyList.$popupBtns['pref'].click();
			e.preventDefault();
		}else if(EPK.PharmacyList.getLineCheckNum() <= 0){
			console.log("station clicked3");
			// 市区が選択されていない時の詳細エリアボタン処理
			EPK.PharmacyList.$popupBtns['line'].click();
			e.preventDefault();
		}
	});

	$('.graf-question').on('click', function() {
		if ($(this).parents().children('.min10-howto').css('display') == 'block') {
			$(this).parents().children('.min10-howto').hide();
		} else {
			$(this).parents().children('.min10-howto').show();
		}
	});
	$('.min10-howto .close').on('click', function() {
		$(this).parents().parents('.min10-howto').hide();
	});

	// タッチの開始時のイベント
	$('.tap').bind('touchstart', function() {
		$(this).css("background-color","#fffeee");
	});
	// タッチ状態から離れたときのイベント
	$('.tap').bind('touchend', function() {
		$(this).css("background-color","#fff");
	});

	// サムネイルの変更処理
	$(".js-shop-thumbnail-list").on('mouseenter', function(e) {
		var $mainImage = $("#" + $(this).attr("data-mainImage"));
		$mainImage.attr('src', $(this).attr("pclist-data-src"));
		$mainImage.attr('alt', $(this).attr("alt"));
	});

	// 上部検索項目
	for (var i = 0; i < $narrow_selected.length; i++) {
		EPK.PharmacyList.changeResearches($narrow_selected[i].id, 0);
	}
	for (var i = 0; i < $narrow_fun.length; i++) {
		var el = $('#' + $narrow_fun[i].id);
		var num = Number(!el.hasClass('shoho'));
		EPK.PharmacyList.changeResearches($narrow_fun[i].id, num);
	}
});

// #9438 非同期化対応
function initMap() {
	if (EPK.mapArgs && typeof google !== "undefined") {
		var mapObj = EPK.shoplistMap(EPK.mapArgs);
	} else {
		// 準備ができていなかった場合のケア
		google.maps.event.addDomListener(window, 'load', initMap);
	}
};

$(function() {
	/**
	 * 絞込のタイプ変更
	 * @type {*}
	 */
	var $box_city = $('#st-menu-box-city');
	var $box_line = $('#st-menu-box-line');

	if(EPK.common.action == "station"){
		$("#searchToggleBtn").text("市区町村から探す");
		$box_city.hide();
		$box_line.show();
	}else{
		$("#searchToggleBtn").text("路線・駅から探す");
		$box_city.show();
		$box_line.hide();
	}

	$("#searchToggleBtn").on('click', function(){
		if($(this).text() === "市区町村から探す"){
			$(this).text("路線・駅から探す");
		}else{
			$(this).text("市区町村から探す");
		}
		$box_city.toggle();
		$box_line.toggle();
	});
});

//全体リンク化で店舗名のブロックの場所を確保できなくなる対応
$(function() {
	//$(".result-box-header").each(function(){
	//	var hi = $(this).height() + 8;
	//	$(this).parent().next().css("padding-top",hi + "px");
	//});

	//店舗画像以下の全コンテンツを特定px分強制的に下げて表示する（<div class="list-result-body">のmargin-topに加算する）
	//店舗名称が1行か2行かによって加算するpx数を動的に変化させる。
	var listResultBodyAddPx = [];
	//$(".list-result-header-box h2").each(function(){
	$(".list-shop-name h2").each(function(){
		var listResultHeaderBoxH2height = $(this).height();

		//店舗名称が1行
		if(listResultHeaderBoxH2height < 23){
			listResultBodyAddPx.push(31);
		}else
		//2行
		if(listResultHeaderBoxH2height < 45){
			listResultBodyAddPx.push(53);
		//3行
		}else{
			listResultBodyAddPx.push(66);
		}
	});
	//$(".list-result-body").each(function(i){
	$(".list-shop-mainbody").each(function(i){
		$(this).css("margin-top", listResultBodyAddPx[i]);
	});
});

/**
 * 地域選択時
 * 駅ポップアップの更新
 */
EPK.PharmacyList.bindCitySearchCheck = function() {
	var $cityCheck  = $(".city_check");
	var $is_pc = $('#is_pc');
	$cityCheck.off('change');
	//再検索のチェックボックス
	$cityCheck.on('change', function() {
		if(($is_pc.length>0)&&($is_pc.val()==1)) {
			var $form = $(this).parents('form:first');
			var query = $form.serialize();
			var callback;
			var $this = $(this);
			if($this.prop("checked")){
				callback = function(data){
					EPK.PharmacyList.redirect2(
						{area_id: $this.attr('area_id')},
						null, null, ["station_cd"]
					);
				};
			}else{
				callback = function(){};
			}
			EPK.PharmacyList.getDetails(
				EPK.PharmacyList.prefCd,
				callback,
				query
			)
		}
	});
};

/**
 * 路線選択時
 * 駅ポップアップの更新
 */
EPK.PharmacyList.bindLineSearchCheck = function() {
	var $lineCheck  = $(".line_check");
	var $is_pc = $('#is_pc');
	$lineCheck.off('change');
	//再検索のチェックボックス
	$lineCheck.on('change', function() {
		if(	$is_pc.length>0
			&& $is_pc.val()==1) {
			var $form = $(this).parents('form:first');
			var query = $form.serialize();
			var callback;
			if($(this).prop("checked")){
				callback = function(data){
					EPK.PharmacyList.getStationCallback(data);
					$('#modal-line-submit-button').click();
				};
			}else{
				callback = EPK.PharmacyList.getStationCallback;
			}
			EPK.PharmacyList.getStations(
				EPK.PharmacyList.prefCd,
				callback,
				query
			)
		}
	});
};

EPK.PharmacyList.bindPrefSearchCheck = function() {
	//都道府県再選択 リファクタ版
	$(".research-check-pref").on('click', function() {
		var prefcd = $(this).attr('data-pref-furi');
		var prefName = $(this).attr('data-pref-name');
		$('input[name=pref_cd]').val(prefcd);
		EPK.PharmacyList.prefCd = prefcd;
		$("#left-side-prefname").text(prefName);
		if(EPK.PharmacyList.selectedPopup == "city") {
			EPK.PharmacyList.getCities(
				prefcd,
				function(data){
					EPK.PharmacyList.getCitiesCallback(data);
					$.magnificPopup.open({
						items: {src: '#modal-select-city'},
						type: 'inline',
					}, 0);
				}
			);
			EPK.PharmacyList.getLines(prefcd, function(data){});
		}else{
			EPK.PharmacyList.getLines(
				prefcd,
				function(data){
					EPK.PharmacyList.getLinesCallback(data);
					$.magnificPopup.open({
						items: {src: '#modal-select-line'},
						type: 'inline',
					}, 0);
				}
			);
			EPK.PharmacyList.getCities(prefcd, function(data){});
		}
	});
};

/**
 * 再検索用のチェックボックスの件数取得callback
 */
EPK.PharmacyList.bindResearchCheck = function(){
	var $reserch_check = $('.research_check');
	var $parent_checkbox = $(".parent_checkbox");

	if($parent_checkbox.size() > 0){
		$parent_checkbox.off('change.research');
		$parent_checkbox.on('change.research', function() {

			var $childList = $("#" + $(this).attr('data-child-checks'));
			var $checkboxes = $childList.find("li .research_check");

			if($(this).prop("checked")){
				$checkboxes.prop('checked', true);
			}else{
				$checkboxes.prop('checked', false);
			}
			$checkboxes.eq(0).trigger("change");
		});

		var $form = $(this).parents('form:first');
		var btnID = $form.attr("data-btnId");
		var $btn = $('#'+btnID);
		var $count = $btn.children('span.shop_count');

		if(EPK.common.action == "condition") {
			EPK.Suggest.calcCountByParamsSuggestRequest();
		}else{
			var suffix = "";
			//if(EPK.PharmacyList.kmBrandId || EPK.common.query.km_brand_page_id){
			//	var brandid = EPK.PharmacyList.kmBrandId || EPK.common.query.km_brand_page_id;
			if(EPK.PharmacyList.cond.km_brand_page_id){
				var brandid = EPK.PharmacyList.cond.km_brand_page_id;
				suffix = '&km_brand_page_id=' + brandid;
			}
			EPK.PharmacySearch.calcCountByForm($form, $count, $btn, undefined, suffix);
		}
	}


	$reserch_check.off('change.research');
	//再検索のチェックボックス
	$reserch_check.on('change.research', function() {
		var $this = $(this);
		var classLabelChecked = "lbl-checked";
		var $form = $this.parents('form:first');
		var btnID = $form.attr("data-btnId");
		var $btn = $('#'+btnID);
		var $count = $btn.find('span.shop_count');
		if($this.prop('checked')){
			$this.closest('label').addClass(classLabelChecked);
		}else{
			$this.closest('label').removeClass(classLabelChecked);
		}

		if(EPK.common.action == "condition") {
			EPK.Suggest.calcCountByParamsSuggestRequest();
		}else{
			var suffix = "";
			//if(EPK.PharmacyList.kmBrandId || EPK.common.query.km_brand_page_id){
			//	var brandid = EPK.PharmacyList.kmBrandId || EPK.common.query.km_brand_page_id;
			if(EPK.PharmacyList.cond.km_brand_page_id){
				var brandid = EPK.PharmacyList.cond.km_brand_page_id;
				suffix = '&km_brand_page_id=' + brandid;
			}
			EPK.PharmacySearch.calcCountByForm($form, $count, $btn, undefined, suffix);
		}
	});
};

/**
 * リダイレクトメソッド
 * 元のパラメータを継承しない
 */
EPK.PharmacyList.redirect = function(data, opt_target_url, opt_paging_reset_flg){
	EPK.PharmacySearch.redirect(data, opt_target_url, opt_paging_reset_flg);
};

/**
 * リダイレクトメソッド
 * 元のパラメータを継承
 */
EPK.PharmacyList.redirect2 = function(data, opt_target_url, opt_paging_reset_flg, except_params){
	if(!except_params){
		except_params = [];
	}
	var mergedQuery = jQuery.extend(EPK.common.params, EPK.common.query);
	except_params.forEach(function(v, i, a){
		delete mergedQuery[v];
	});
	data = jQuery.extend(mergedQuery, data);
	EPK.PharmacySearch.redirect(data, opt_target_url, opt_paging_reset_flg);
};

/**
 * クエリの取得関数
 * @param data
 * @param paging_reset_flg
 */
EPK.PharmacyList.getQuery = function(data, paging_reset_flg){
	var mergedQuery = jQuery.extend({}, EPK.common.params, EPK.common.query);
	var params = jQuery.extend({}, mergedQuery, data);
	return $.param(EPK.PharmacySearch.cleanParams(params, paging_reset_flg));
};

/**
 * 新リダイレクトメソッド用のデータ整形関数
 * 多次元配列は非対応
 * @param $form
 * @param data
 * @param opt_suffix
 */
EPK.PharmacyList.appendForm = function($form, data, opt_suffix){
	var suffix = opt_suffix;
	if(typeof opt_suffix=="undefined"){
		var suffix = "";
	}

	for(var key in data) {
		var value = data[key];
		if(typeof value === 'object'){
			for(var key2 in value) {
				$form.append($('<input/>', {'type': 'hidden', 'name': key+"[]", 'value': value[key2]}));
			}
		}else{
			$form.append($('<input/>', {'type': 'hidden', 'name': key, 'value': data[key]}));
		}
	}
};


/**
 * 検索項目を増減させてリダイレクト
 */
EPK.PharmacyList.changeResearches = function(id, val) {
	var option = {};

	if (id == 'modal-select-change-btn') return;
	if (id == 'narrow_selected_pref_cd') {
		$('#' + id).on('click', function(e){
			// 全国へ戻る
			option['area_id'] = '';
			option['pref_cd'] = '';
			option['station_cd'] = '';
			EPK.PharmacyList.redirect2(option, '/s', true);
		});
		return;
	}

	var key = id;
	key = key.replace('narrow_selected_', '');
	key = key.replace('narrow_fun_', '');
	option[key] = val;
	$('#' + id).on('click', function(e){
		EPK.PharmacyList.redirect2(option, location.pathname, true);
	});
};

/*****************************************
 *  API問い合わせ >>>
 *  ここは後で共通化
 *  EPK.Api 的な名前空間で
 */

/**
 * 都道府県の取得
 * @param callback
 */
EPK.PharmacyList.getPrefs = function(callback){
	var url = "/api/prefs/counts";
	if(EPK.PharmacyList.cond.km_brand_page_id){
		url = url + "?km_brand_page_id=" + EPK.PharmacyList.cond.km_brand_page_id;
	}
	$.ajax({
		type: 'get',
		url: url,
		cache: true,
		timeout: 60000
	}).done(function(data){
		callback(data);
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};

/**
 * 市区一覧の取得
 * @param pref_cd 都道府県コード
 * @param callback function(data:json)
 */
EPK.PharmacyList.getCities = function(pref_cd, callback){
	var url = "/api/" + pref_cd + "/cities.json";
	if(EPK.PharmacyList.cond.km_brand_page_id){
		url = url + "?km_brand_page_id=" + EPK.PharmacyList.cond.km_brand_page_id;
	}
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: url,
		cache: false,
		timeout: 60000
	}).done(function(data){
		callback(data);
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};

/**
 * 路線一覧の取得
 * @param pref_cd
 * @param callback
 */
EPK.PharmacyList.getLines = function(pref_cd, callback){
	var url = "/api/" + pref_cd + "/lines.json";
	if(EPK.PharmacyList.cond.km_brand_page_id){
		url = url + "?km_brand_page_id=" + EPK.PharmacyList.cond.km_brand_page_id;
	}
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: url,
		cache: false,
		timeout: 60000
	}).done(function(data){
		callback(data);
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};

/**
 * 駅一覧の取得
 * @param pref_cd
 * @param callback
 */
EPK.PharmacyList.getStations = function(
	pref_cd,
	callback,
	opt_lineParams
){
	var lineParams = opt_lineParams;
	var url = "/api/" + pref_cd + "/stations.json";

	if(typeof opt_lineParams == "undefined"){
		lineParams = "";
	}
	if(EPK.PharmacyList.cond.km_brand_page_id){
		url = url + "?km_brand_page_id=" + EPK.PharmacyList.cond.km_brand_page_id;
	}
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: url,
		data: lineParams,
		cache: false,
		timeout: 60000
	}).done(function(data){
		callback(data);
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};

/**
 * 詳細地区の取得
 * @param pref_cd
 * @param callback
 */
EPK.PharmacyList.getDetails = function(
	pref_cd,
	callback,
	opt_city_params
){
	var cityParams = opt_city_params;
	var url = "/api/" + pref_cd + "/area/details.json";

	if(typeof opt_city_params == "undefined"){
		cityParams = "";
	}
	if(EPK.PharmacyList.cond.km_brand_page_id){
		url = url + "?km_brand_page_id=" + EPK.PharmacyList.cond.km_brand_page_id;
	}
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: url,
		data: cityParams,
		cache: false,
		timeout: 60000
	}).done(function(data){
		callback(data);
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};

/**
 * エリアの駅一覧を取得
 * ※仕様削減により未使用
 * @param pref_cd
 * @param callback
 */
EPK.PharmacyList.getStationsByAreaId = function(
	pref_cd,
	callback,
	opt_city_params
){
	var cityParams = opt_city_params;
	var url = "/api/" + pref_cd + "/area/stations.json";

	if(typeof opt_city_params == "undefined"){
		cityParams = "";
	}
	$.ajax({
		type: 'get',
		dataType: 'json',
		url: url,
		data: cityParams,
		cache: false,
		timeout: 60000
	}).done(function(data){
		callback(data);
	}).fail(function(){
		// アクション側でExceptionが投げられた場合はここに来る。
		// エラーをここで処理したい場合はExceptionを投げても良い
	});
};

/**
 *  <<< API問い合わせ
 *****************************************/

/**
 * 市区ポップアップ初期化用のコールバック
 * @param data
 */
EPK.PharmacyList.getCitiesCallback = function(data){
	data["selected_cities"] = EPK.PharmacyList.cityIds;
	data["pref_cd"] = EPK.PharmacyList.prefCd;
	data["a_tag"] = "a href";

	var $template = $.templates('#city-popup');
	var $target = $("#area_checkboxes");
	var htmlOutput = $template.render(data);

	$target.empty();
	$target.append(htmlOutput);
	EPK.PharmacyList.bindResearchCheck();
	EPK.PharmacyList.bindCitySearchCheck();
	EPK.PharmacyList.cityInitialized = true;
};

/**
 * 路線ポップアップ初期化用のコールバック
 * @param data
 */
EPK.PharmacyList.getLinesCallback = function(data){
	data["selected_lines"] = EPK.PharmacyList.lineCds;

	var $template = $.templates('#line-popup');
	var $target = $("#line_checkboxes");
	var htmlOutput = $template.render(data);

	$target.empty();
	$target.append(htmlOutput);
	EPK.PharmacyList.bindResearchCheck();
	EPK.PharmacyList.bindLineSearchCheck();
	EPK.PharmacyList.lineInitialized = true;
};

/**
 * 都道府県ポップアップ初期化用のコールバック
 * @param data
 */
EPK.PharmacyList.getPrefCallback = function(data){
	data["selected_pref"] = EPK.PharmacyList.prefCd;

	var $target = $("#modal-select-pref-container");

	$target.empty();
	$target.append(data);
	EPK.PharmacyList.bindResearchCheck();
	EPK.PharmacyList.bindPrefSearchCheck();
	EPK.PharmacyList.prefInitialized = true;
}

/**
 * 市区ポップアップの初期化
 * @param pref_cd
 */
EPK.PharmacyList.initCityPopup = function(pref_cd){
	EPK.PharmacyList.getCities(pref_cd, EPK.PharmacyList.getCitiesCallback)
};;

/**
 * 路線ポップアップの初期化
 * @param pref_cd
 */
EPK.PharmacyList.initLinePopup = function(pref_cd){
	EPK.PharmacyList.getLines(pref_cd, EPK.PharmacyList.getLinesCallback)
};

/**
 * 路線ポップアップの初期化
 * @param pref_cd
 */
EPK.PharmacyList.initPrefPopup = function(){
	EPK.PharmacyList.getPrefs(EPK.PharmacyList.getPrefCallback)
};

/**
 * 駅ポップアップ初期化用のコールバック
 * @param data
 */
EPK.PharmacyList.getStationCallback = function(data){
	data["selected_stations"] = EPK.PharmacyList.stationCds;
	data["pref_cd"] = EPK.PharmacyList.prefCd;
	data["a_tag"] = "a href";

	var $template = $.templates('#station-popup');
	var $target = $("#station_checkboxes");
	var htmlOutput = $template.render(data);

	$target.empty();
	$target.append(htmlOutput);

	EPK.PharmacyList.bindResearchCheck();
	EPK.PharmacyList.staionInitialized = true;

};

/**
 * 駅ポップアップの初期化
 * @param pref_cd
 */
EPK.PharmacyList.initStationPopup = function(pref_cd){
	var queryObj = {};
	queryObj["line_cd"] = [];
	EPK.PharmacyList.lineCds.forEach(
		function logArrayElements(element, index, array) {
			queryObj["line_cd"].push(element);
		}
	);
	var params = $.param(queryObj);
	EPK.PharmacyList.getStations(
		pref_cd,
		EPK.PharmacyList.getStationCallback,
		params);
};

/**
 * 詳細地域ポップアップ初期化用のコールバック
 * @param data
 */
EPK.PharmacyList.getDetailCallback = function(data){
	data["selected_details"] = EPK.PharmacyList.areaCds;
	data["pref_cd"] = EPK.PharmacyList.prefCd;
	data["a_tag"] = "a href";
	var cities_name = "";
	var cities = data["cities"];


	var $template = $.templates('#detail-popup');
	var $target = $("#detail_checkboxes");
	var htmlOutput = $template.render(data);


	$target.empty();
	$target.append(htmlOutput);
	EPK.PharmacyList.bindResearchCheck();
	EPK.PharmacyList.detailInitialized = true;

	/**
	 * 市区名リスト代入
	 */
	Object.keys(cities).forEach(function(key){
		var element = cities[key];
		if(cities_name==""){
			cities_name = element["city_name"];
		}else{
			cities_name = cities_name + "、" + element["city_name"];
		}
		$("#label-selected_city_names").text(cities_name);
	});
};

/**
 * 駅一覧ポップアップ初期化用のコールバック
 * ※仕様削減により未使用
 * @param data
 */
EPK.PharmacyList.getAreaStationCallback = function(data){
//console.log(data);
}

/**
 * 市区のチェック数取得
 */
EPK.PharmacyList.getCityCheckNum = function(){
	return $("#form-modal-select-city").find(".city_check:checked").length;
};

/**
 * 路線のチェック数取得
 */
EPK.PharmacyList.getLineCheckNum = function(){
	return $("#form-modal-select-line").find(".line_check:checked").length;
};


/**
 * 詳細地域ポップアップの初期化
 * @param pref_cd
 */
EPK.PharmacyList.initDetailPopup = function(pref_cd){
	var areaCdObj = {};
	areaCdObj["area_id"] = [];

	EPK.PharmacyList.areaCds.forEach(
		function logArrayElements(element, index, array) {
			areaCdObj["area_id"].push(element);
		}
	);
	if(EPK.PharmacyList.areaCds.length !== 0){
		EPK.PharmacyList.getDetails(
			pref_cd,
			EPK.PharmacyList.getDetailCallback,
			areaCdObj
		)
	}
};

/**
 * 駅一覧ポップアップの初期化
 * ※仕様削減により未使用
 * @param pref_cd
 */
EPK.PharmacyList.initAreaStationPopup = function(pref_cd){
	var areaCdObj = {};
	areaCdObj["area_id"] = [];

	EPK.PharmacyList.areaCds.forEach(
		function logArrayElements(element, index, array) {
			areaCdObj["area_id"].push(element);
		}
	);
	if(EPK.PharmacyList.areaCds.length !== 0){
		EPK.PharmacyList.getStationsByAreaId(
			pref_cd,
			EPK.PharmacyList.getAreaStationCallback,
			areaCdObj
		)
	}
};

EPK.PharmacyList.getResearchParams = function(){
	var params = EPK.utils.getFormParamsArray($("#reserch-conditions"));
	return $.extend(true, {}, params, EPK.PharmacyList.suggestedParams);
};

/**
 * こだわり条件スライダー初期化
 */
EPK.PharmacyList.initCriteriasSwiper = function() {
	var id = '#criterias_swiper';
	$(id).swiper({
		slidesPerView: 'auto',
	});
}

/**
 * 処方薬から探す　サジェスト
 */
EPK.PharmacyList.initSuggest = function () {

	EPK.Suggest.init(EPK.PharmacyList.cond);

	// クロージャ使わず 関数上書き（処方薬用）
	EPK.Suggest.open = function(mode){

		EPK.Suggest.$wrapper.show();
		if(!EPK.Suggest.isFixedFooter) {
			EPK.Suggest.$footer.show();
		}

		EPK.Suggest.isClosed = false;

		// 表示切り替え（処方薬用）
		$('.fw-text-area-freeword').hide();
		$('.fw-text-area-medicine').show();

		// スクロール領域高さ計算
		$('body').css({
			position: 'fixed',
		});

		var height = $(window).height();
		var header = $(".fw-header").innerHeight();
		var footer = EPK.Suggest.$footer.innerHeight();
		var tweak = 5;
		var suggestListBoxHeight = height - header - footer - tweak;

		$('.suggest-list-box').css('height', suggestListBoxHeight+'px');

		// 強制的にis_netを上げる
		EPK.Suggest.$is_net.prop('checked', true);
		EPK.PharmacyList.suggestedParams["is_net"] = 1;
		EPK.Suggest.setIsNet(true, false);

		if(EPK.common.query["is_coupon"]){
			EPK.Suggest.$is_coupon.prop('checked', true);
			EPK.PharmacyList.suggestedParams["is_coupon"] = 1;
			EPK.Suggest.setIsCoupon(true, false);
		}else{
			EPK.Suggest.$is_coupon.prop('checked', false);
			delete EPK.PharmacyList.suggestedParams["is_coupon"];
			EPK.Suggest.setIsCoupon(false, false);
		}
		if(EPK.common.query["is_open"] && EPK.common.query["is_open"] == 1){
			EPK.Suggest.$is_open.prop('checked', true);
			EPK.PharmacyList.suggestedParams["is_open"] = 1;
			EPK.Suggest.setIsOpen(true, false);
		}else{
			EPK.Suggest.$is_open.prop('checked', false);
			delete EPK.PharmacyList.suggestedParams["is_open"];
			EPK.Suggest.setIsOpen(false, false);
		}

		EPK.Suggest.calcCountByParamsSuggest();

	};

	// クロージャ使わず 関数上書き（処方薬用）
	EPK.Suggest.close = function(){
		EPK.Suggest.$wrapper.hide();
		if(!EPK.Suggest.isFixedFooter){
			EPK.Suggest.$footer.hide();
		}
		EPK.Suggest.isClosed = true;

		$('body').css({
			position: 'relative',
		});
	};

	// フッタのsubmitボタンイベント上書き
	EPK.Suggest.$footerBtn.off('click.suggest');
	EPK.Suggest.$footerBtn.on('click.suggest', function(e){
		e.preventDefault();
		if(EPK.Suggest.$footer.hasClass("is-disable-gray")){
			return;
		}
		// 強制的にis_netを立てる
		EPK.Suggest.searchParam['is_net'] = '1';
		EPK.PharmacySearch.redirect(EPK.Suggest.searchParam);
	});

	// ネット受付対応ボタンクリック時、メッセージ表示
	EPK.Suggest.$is_net.on('click', function(e){
		EPK.Suggest.$is_net.prop('checked', true);
		$('.fw-check').after('<span class="note">※処方された医薬品名からの検索は、ネット受付対応店舗にかぎります。</span>');
		// メッセージ表示後ボタンをdisabledにする
		EPK.Suggest.$is_net.prop('disabled', true);
	});
};
/**
 * PCブランドチラシ用のエリアから探す機能のイベント登録
 * @method initBrandTirashiaSearch
 */
EPK.PharmacyList.initBrandTirashiaSearch = function () {
	// 選択中のエリア情報を更新
	var defaultArea = EPK.PharmacyList.selectBrandTirashiArea;
	if(defaultArea && defaultArea !== 'zenkoku') {
		var selectEl = defaultArea ? document.querySelector('.area-search-body a[href*="'+defaultArea + '"]') : null;
		// 選択都道府県が含まれるliのinputタグを取得
		var parentLi = selectEl ? selectEl.parentNode.parentNode.parentNode : null;
		var areaInputs = parentLi ? parentLi.getElementsByTagName('input') : null;
		if(areaInputs && areaInputs.length) {
			// 選択状態の表示に変更
			areaInputs[0].checked = true;
		}
		EPK.PharmacyList.changeSelectBrandTirashiAreaEl(selectEl);
	}
	// イベント登録
	EPK.PharmacyList.setBrandTirashiaAreaEvent();

	//近い順イベント
	EPK.PharmacyList.closestOrderBrandChirashi();
	//郵便番号入力欄表示イベント
	var notSetBtn = document.getElementById('notSetPostalCode');
	var inputForm = document.getElementById('postalCodeForm');
	if (notSetBtn && inputForm) {
		notSetBtn.addEventListener('click',function () {
			notSetBtn.style.display = 'none';
			inputForm.style.display = '';
		},false);
	}

	//エリアからさがす都道府県表示イベント
	EPK.PharmacyList.openAreaBrandChirashi();
	//営業時間の非同期取得
	EPK.PharmacyList.getOpenTimebrandChirashi();

};
/**
 * PCブランドチラシ用のエリアから探す機能のイベント登録
 * @method setBrandTirashiaEvent
 */
EPK.PharmacyList.setBrandTirashiaAreaEvent = function () {
	// 都道府県の要素をクリックイベント登録
	var input = document.getElementById('zip_code1');
	if(input) {
		input.addEventListener('input', EPK.PharmacyList.onChangePostNumber1)
	}
};
/**
 * PCのブランド下層のチラシ用都道府県選択時イベント
 * @method onClickBrandTirashiaAreaBtn
 * @param {Event} event
 */
EPK.PharmacyList.onClickBrandTirashiaAreaBtn = function (event) {
/*	event.preventDefault();
	var selectEl = this;
	// 選択中の要素を変更
	EPK.PharmacyList.changeSelectBrandTirashiAreaEl(selectEl);
	// URL変更処理
	EPK.PharmacyList.changeUrlOfBrandTirashi(selectEl);
	return false;
*/
};
/**
 * PCの郵便番号入力(3桁のinput)イベント
 * @method onChangePostNumber1
 * @param {Event} event
 */
EPK.PharmacyList.onChangePostNumber1 = function (event) {
	var value = this.value;
	if(value.length >= 3) {
		// 3文字以上入力された場合
		document.getElementById('zip_code2').focus();
	}
};
/**
 * PCのブランドチラシの選択都道府県の要素表示を変更
 * @method setSelectBrandTirashiArea
 * @param {Element} selectEl
 */
EPK.PharmacyList.changeSelectBrandTirashiAreaEl = function (selectEl) {
	var _selectEl = selectEl;
	// 選択済みだった要素を未選択状態に変更
	var areaBody = document.getElementsByClassName('area-search-body')
	var selectedEls = areaBody.length ? areaBody[0].getElementsByClassName('is-active') : [];

	var selectedLen = selectedEls.length;
	if (selectedLen !== 0) {
		for (var selectedIdx = 0; selectedIdx < selectedLen; selectedIdx++) {
			var el = selectedEls[0];
			if(el ) el.classList.remove('is-active');
		}
	}
	// クリックした要素を選択済み変更
	if(_selectEl) {
		_selectEl.parentElement.classList.add('is-active');
	}
};
/**
 * #10203 PC版ブランドチラシTOP改修
 * PCブランドチラシの近い順イベント
 * @method closestOrderBrandChirashi
 */
EPK.PharmacyList.closestOrderBrandChirashi = function (el) {
	
	var closestOrderBtn = document.getElementById('closestOrder');
	if (!closestOrderBtn) return;

	closestOrderBtn.addEventListener('click',function () {
		EPK.PharmacyList.getCurrentPlace();
	});

};
/**
 * #10203 PC版ブランドチラシTOP改修
 * PCブランドチラシの近い順 位置情報の取得
 * @method getCurrentPlace
 */
EPK.PharmacyList.getCurrentPlace = function (el) {
	
	var showError=true;
	var errorInfo = [
		"原因不明のエラーが発生しました。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"位置情報が正しく計測されませんでした。\n圏外でない場合は、端末の位置情報サービスの設定が有効になっているかご確認ください。",
		"電波状況などで位置情報が取得できませんでした。電波状況のいいところで再度お試しください。",
		"位置情報の取得に時間がかかり過ぎてタイムアウトしました。電波状況のいいところで再度お試しください。"
	];

	var showAlertErrorMessage = function(){
		// エラーメッセージ
		var errorMessage = errorInfo[EPK.currentPlace.errorNo];

		// アラート表示
		alert(errorMessage);
	};

	var errorHandler = function(error) {
		// エラーコード(error.code)の番号
		// 0:UNKNOWN_ERROR				原因不明のエラー
		// 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
		// 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
		// 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…

		// エラー番号
		var errorNo = error.code;
		var inOneMinutes = new Date(new Date().getTime() + 1 * 60 * 1000);
		Cookies.set('errorNo', errorNo, { expires: inOneMinutes} );
		EPK.currentPlace.errorNo = errorNo;
		if(!showError){
			console.log('現在位置が取得できませんでした。');
			console.log(errorInfo[errorNo]);
			console.log('errorNo:' + errorNo);
			return;
		}
		console.error(error);
		showAlertErrorMessage();
	};

	var moveToLocationSearch =  function (position){
		// データの整理
		// 取得したデータの整理
		var data = position.coords;
		var lat = data.latitude;
		var lon = data.longitude;
		
		//遷移先ＵＲＬの生成と遷移
		location.href = location.pathname + '?lat=' + lat +'&lon=' + lon;

	};

	var getCurrentPlace = function(callback, argShowError, argUseCookie){

		// エラー表示の切り替え
		// グローバル変数: showError に情報隔離
		if(argShowError != null){
			showError = argShowError;
		}

		if(typeof argUseCookie == "undefined") {
			argUseCookie = true
		}

		if(argUseCookie){
			var tmpLat = Cookies.get('lat');
			var tmpLng = Cookies.get('lng');
			var tmpErrNo = Cookies.get('errorNo');
			if(tmpLat && tmpLng) {
				EPK.common.latlng.lat = tmpLat*1.0;
				EPK.common.latlng.lng = tmpLng*1.0;
				callback({coords: {latitude: tmpLat, longitude: tmpLng}});
				return;
			}
			if(tmpErrNo){
				EPK.currentPlace.errorNo = tmpErrNo;
			}
		}

		// ユーザーの端末がGeoLocation APIに対応しているかの判定
		// 対応している場合
		if (navigator.geolocation) {
			// 現在地を取得
			navigator.geolocation.getCurrentPosition(
				// [第1引数] 取得に成功した場合の関数
				function(position){
					var data = position.coords ;
					var lat = data.latitude;
					var lng = data.longitude;

					EPK.common.latlng.lat = lat;
					EPK.common.latlng.lng = lng;

					callback(position);
				},
				// [第2引数] 取得に失敗した場合の関数
				errorHandler.bind(this),

				// [第3引数] オプション
				{
					"enableHighAccuracy": false,
					"timeout": 8000,
					"maximumAge": 2000,
				}
			);
		} // 対応していない場合
		else if(showError) {
			// エラーメッセージ
			var errorMessage = "現在地情報を取得できませんでした。<br>端末の設定より現在地情報サービスをオンにして下さい。";

			// アラート表示
			alert(errorMessage);
		}
	};

	getCurrentPlace(moveToLocationSearch, true, false);
};
/**
 * #10203 PC版ブランドチラシTOP改修
 * エリアからさがすのイベント
 * @method openAreaBrandChirashi
 */
EPK.PharmacyList.openAreaBrandChirashi = function (el) {
	
	//都道府県表示イベント
	var openAreaBtn = document.getElementById('openArea');
	var allArea = document.getElementById('allArea');
	if (openAreaBtn && allArea) {

		document.body.addEventListener('click',function (e) {

			if (e.target.id == openAreaBtn.id) {
				//全国ボタンを押した場合
				if (allArea.style.display == 'none') {
					allArea.style.display = '';
				}
				
				//生のclosestはie11未対応の為jqueryにて対応
			} else if ($(e.target).closest('#allArea') && $(e.target).closest('#allArea').attr('id') == allArea.id){
				//モーダル内を押した場合
				if (allArea.style.display == '') {
					return;
				}
			} else {
				//それ以外を押した場合
				if (allArea.style.display == '') {
					allArea.style.display = 'none';
				}
			}

		},false);
	}
};
/**
 * #10236 ブランドチラシTOP改修
 * 営業時間の非同期取得
 * @method getOpenTimebrandChirashi
 */
EPK.PharmacyList.getOpenTimebrandChirashi = function () {

	var shopList = document.querySelectorAll('div.flyer-shopbox[data-shopid]');
	var shopIds = [];
	var pharmacyTypes = [];
	if (shopList.length > 0) {
		for (var i = 0; i < shopList.length; i++) {
			if (shopList[i].getAttribute('data-shopid')) {
				shopIds.push(shopList[i].getAttribute('data-shopid'));
			}
			if (shopList[i].getAttribute('data-pharmacyType')) {
				pharmacyTypes.push(shopList[i].getAttribute('data-pharmacyType'));
			}
		}
		
		if (shopIds.length == pharmacyTypes.length) {

			$.ajax({
				type: 'get',
				url: '/api/list/today_open_time_for_brand_chirashi',
				data: {
					'shop_id': shopIds,
					'pharmacy_type': pharmacyTypes
				},
				cache: false,
				dataType : 'html',
			}).done(function(resultData){
				var body = document.querySelector('body');
				if (resultData && body) {
					body.insertAdjacentHTML('beforeend',resultData);
					var salestimes = document.querySelectorAll('.salestime[data-salestime]');
					if (salestimes.length > 0) {
						for (var i = 0; i < salestimes.length; i++) {
							var shopbox = document.querySelector('div.flyer-shopbox[data-shopid="'+salestimes[i].getAttribute('data-salestime')+'"]');
							if (shopbox) {
								var salsetime = shopbox.querySelector('.salestime');
								salsetime.insertAdjacentElement('afterend',salestimes[i]);
								salsetime.parentElement.removeChild(salsetime);
							}
						}
					}
				}
			}).fail(function(){
			});
		}
	}
};
/**
 * PCのブランドチラシの画面URLを変更
 * @method changeUrlOfBrandTirashi
 * @param {Element} el
 */
EPK.PharmacyList.changeUrlOfBrandTirashi = function (el) {
	// URL変更処理
/*	var Urlkey = 'com';
	var _el = el;
	var elHref = $(_el).attr("href");
	var _href = _el.href;
	var nextURL = _href.substring(0, _href.indexOf(Urlkey) + Urlkey.length);
	// 全国以外の場合のaタグのhrefを設定する
	nextURL = nextURL + (elHref ? '' + elHref : '');
	if (location.href !== nextURL) {
		// URLが異なる場合は画面遷移を実行
		location.href = nextURL;
	}
*/
};

EPK.PharmacyList.getReviewsHtml = function() {
    var listPattern = /^\/.*\/list\/(\d+$|\d+\?.*)$/;
    var linePattern = /^\/.*\/line\/station\/(\d+$|\d+\?.*)$/;
    var path = location.pathname + location.search;
    if (listPattern.test(path) || linePattern.test(path)) {
        var url = '/api' + path;
        $.ajax({
            type: 'get',
            url: url,
            cache: false,
            timeout: 60000
        })
        .done(function(data) {
			var html = JSON.parse(data).result;
            var reviewBoxEl = document.querySelector('.bottomlist');
            if (reviewBoxEl && html !== '') {
                reviewBoxEl.insertAdjacentHTML('afterbegin', html);
			}

			/* 201910 使用しなくなったのでコメント化
			// もっと見るボタンの制御
			var reviewMoreEl = document.querySelector('.list-review-more');

			if (reviewMoreEl) {
				// 初期化
				reviewMoreEl.getAttribute('data-show') || reviewMoreEl.setAttribute('data-show', true);

				reviewMoreEl.addEventListener('click', function(e) {
					e.preventDefault();
					var nodeList = document.querySelectorAll('.list-review-block');
					if (reviewMoreEl.getAttribute('data-show')) {
						for (var i = 0; i < nodeList.length; i++) {
							if (nodeList[i].style.display === 'none') {
								nodeList[i].style.display = 'block';
							}
						}
						document.querySelector('.list-review-more a').innerText = '閉じる';
						reviewMoreEl.setAttribute('data-show', '');
					} else {
						for (var i = 0; i < nodeList.length; i++) {
							if (nodeList[i].style.display === 'block') {
								nodeList[i].style.display = 'none';
							}
						}
						document.querySelector('.list-review-more a').innerText = 'もっと見る';
						reviewMoreEl.setAttribute('data-show', true);
					}
				});
			}
			*/
        })
        .fail(function(err) {
            console.log(err);
		});
	}
};

$('.ad_shops').each(function(element, index){})

$(function() {
	var showFlag = false;
	var topBtn = $('#go-to-top');
	topBtn.css('bottom', '-100px');
	// #6472 SP_list改修：フロート再検索枠のスクロールfade-up
	if(EPK.common.isMobile) {
		var showFlagFUFooter = false;
		var fadeUpFooter = $('#fade-up-footer');
		fadeUpFooter.css('bottom', '-100px');
	}
	//スクロールが100に達したらボタン表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			if (showFlag == false) {
				showFlag = true;
				topBtn.stop().animate({'bottom' : '20px'}, 200);
			}
		} else {
			if (showFlag) {
				showFlag = false;
				topBtn.stop().animate({'bottom' : '-100px'}, 200);
			}
		}
		// #6472 SP_list改修：フロート再検索枠のスクロールfade-up
		if(EPK.common.isMobile) {
			if($(this).scrollTop() > 400) {
				if(showFlagFUFooter == false) {
					showFlagFUFooter = true;
					fadeUpFooter.stop().a

					nimate({'bottom' : '0px'}, 300);
				}
			} else {
				if(showFlagFUFooter) {
					showFlagFUFooter = false;
					fadeUpFooter.stop().animate({'bottom' : '-100px'}, 300);
				}
			}
		}
	});
	//スクロールしてトップ
	topBtn.click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});
	// ブランドチラシの初期化
	EPK.PharmacyList.initBrandTirashiaSearch();

	// 処方薬から探す　サジェスト初期化
	if(EPK.common.isMobile && EPK.PharmacyList.dispensing_search_flag !== undefined) {
		EPK.PharmacyList.initSuggest();
	}

	// PCリストページ下に新着の口コミ追加
	EPK.PharmacyList.getReviewsHtml();
});
